// extracted by mini-css-extract-plugin
export default {"ace-c-dashboard-section-screen__time-period-tab-bar":"dashboard-section-screen__time-period-tab-bar---338ca4f1"};